"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capriva-del-friuli": {
    "1f24bb36": [{
      "hkey": "28e57800",
      "slug": "capriva-del-friuli",
      "name": "Capriva del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "russiz": [{
      "hkey": "28e57800",
      "slug": "capriva-del-friuli",
      "name": "Capriva del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56c20181": [{
      "hkey": "28e57800",
      "slug": "capriva-del-friuli",
      "name": "Capriva del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "spessa": [{
      "hkey": "28e57800",
      "slug": "capriva-del-friuli",
      "name": "Capriva del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;